module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fmtitlea"
  }, [_c('a', {
    attrs: {
      "id": "page_i"
    }
  }, [_vm._v("Praise for")])]), _c('a', {
    attrs: {
      "id": "page_i"
    }
  }, [_c('h1', {
    staticClass: "fmtitle1a"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Lord Valentine’s Castle")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“[A] heady blend of rigorous SF world building and the poetic sensibility of fantasy fiction.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—Sci Fi Weekly")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“A grand, picaresque tale … by one of the great storytellers of the century. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lord Valentine’s Castle")]), _vm._v(" has everything.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—Roger Zelazny")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Silverberg has created a big planet, chockablock with life and potential.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Washington Post")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“This absorbing book is … successful in creating a wildly imaginative universe. It is also better written than most in this genre and deserves to be one of the year’s hits, sci-fi or otherwise.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("People")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“In this richly imagined setting, Valentine not only learns about his world but about himself and his proper place in it…. Robert Silverberg’s writing and imagination soar with nary a false step. It is truly an extraordinary tale, well told.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—SFFaudio")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a97bbdaa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml1/04_Praise.vue
// module id = 72
// module chunks = 0